import { render, staticRenderFns } from "./TextSetting.vue?vue&type=template&id=46fb4a96"
import script from "./TextSetting.vue?vue&type=script&lang=js"
export * from "./TextSetting.vue?vue&type=script&lang=js"
import style0 from "./TextSetting.vue?vue&type=style&index=0&id=46fb4a96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports